import { RefObject, useEffect, useState } from 'react';

export const useScroll = (
  containerRef: RefObject<HTMLDivElement | null>,
  deps: unknown[],
) => {
  const [isScrollable, setIsScrollable] = useState<boolean>(false);

  useEffect(() => {
    if (
      containerRef.current &&
      containerRef.current.clientHeight !== containerRef.current.scrollHeight
    ) {
      setIsScrollable(true);
    } else {
      setIsScrollable(false);
    }
  }, [deps, containerRef]);

  return { isScrollable };
};
